/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
  MdOutlineTimer,
} from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import HearColor from "./HearColor";
import { FaArrowLeft, FaArrowRight, FaPlus } from "react-icons/fa";
import SelectProfessional from "./SelectProfessional";
import { TiTick } from "react-icons/ti";
import {
  selectedServices,
  selectedServicesNew,
  toggleService,
} from "../../Slice/serviceSlice";
import { axiosInstance } from "../../utils/axiosInstance";
import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import SelectedServices from "./selectedServices";
// import DatePicker from "./DatePicker";

export default function Pakages({ service, provider, saloon }) {
  const { Services, Provider } = useSelector((state) => state.auth);
  const { SelectedService, provider_services } =
    Provider.provider_category_detail;
  console.log(Provider, "Provider");
  console.log(SelectedService, "SelectedService");

  const categoryexit = localStorage.getItem("category");

  const category = localStorage.getItem("category");
  console.log(saloon?.provider_category_profiles, "dasfsaf");
  const filteredCategories =
    saloon?.provider_category_profiles?.filter(
      (e) => e?.provider_category?.name === category
    ) || [];

  console.log(filteredCategories, "filter");

  const [serviceName, setServiceName] = useState([]);
  const [selectedprofile, setselectedprofile] = useState({});
  console.log(selectedprofile, "prof");

  const dispatch = useDispatch();
  const fetchProviders = async (id) => {
    console.log(id, "sdsad");
    Status(id);
    await axiosInstance
      .get(`category-service/${id}`)
      .then((res) => {
        console.log(res?.data?.category_service?.services, "asdasf");
        if (res?.data?.category_service?.services?.length > 0) {
          setServiceName(res?.data?.category_service?.services);
        }
      })
      .catch((err) => console.log(err));
  };

  const [selectedIds, setSelectedIds] = useState([]);

  const handleToggle = (e) => {
    if (selectedIds.includes(e)) {
      // Remove ID if already selected
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== e));
    } else {
      // Add ID if not selected
      setSelectedIds([...selectedIds, e]);
    }
  };

  const [continues, setcontinues] = useState(false);

  const [active, setactive] = useState("");
  const [active2, setactive2] = useState("");
  console.log(active2, "avtice2");
  const Status = (id) => {
    setactive(id);
  };

  const Status2 = (id) => {
    setactive2(id);
  };
  useEffect(() => {
    if (filteredCategories) {
      setselectedprofile(filteredCategories?.[0]);
      Status2(filteredCategories?.[0]?.id);
      Status(filteredCategories?.[0]?.provider_category_services?.[0]?.id);
    }

    const id = service?.[0]?.id;
    if (id && categoryexit) {
      fetchProviders(id);
    }
  }, [service]); // Dependencies to re-run the effect

  return (
    <>
      <div className="container pt-5" style={{ backgroundColor: "white" }}>
        <div className="row gap-2">
          <div className="col-md-7 col-12 gap-2">
            {continues ? (
              <SelectProfessional />
            ) : (
              <div>
                <h1 className="text-dark">Services</h1>
                {/* Left Arrow */}
                {serviceName?.length < 0 ? <h1>Service Not Found</h1> : ""}
                {/* Scrollable Buttons Container */}
                <div style={{height:"80px"}}>
               <h6 className="font-weight-bold">Business</h6> 
                <div className="w-full" style={{ border: "1px solid black" }} />
                <Swiper
                  className="mt-2"
                  slidesPerView={4}
                  spaceBetween={2}
                  navigation={{
                    nextEl: ".next",
                    prevEl: ".prev",
                  }}
                  modules={[Navigation]}
                >
                  {saloon?.provider_category_profiles?.length>0?saloon?.provider_category_profiles?.map((e) => {
                    return (
                      <SwiperSlide key={e.id}>
                        <button
                          className="btn-defaultS"
                          style={{
                            backgroundColor:
                              e.id === active2 ? "black" : "white",
                            color: e.id === active2 ? "white" : "black",
                            border:
                              e.id === active2 ? "1px solid black" : "none",
                          }}
                          onClick={() => {
                            Status("");
                            setselectedprofile(e);
                            Status2(e.id);
                            if (e?.provider_category_services?.length > 0) {
                              console.log(
                                e?.provider_category_services,
                                "erads"
                              );
                              // fetchProviders(e?.provider_category_services?.id)
                              setServiceName([]);
                            }
                          }}
                        >
                          {e?.provider_category?.name}
                        </button>
                      </SwiperSlide>
                    );
                  }): <h6
                  className={`w-full mt-4 text-danger font-weight-bold ${
                    selectedprofile?.provider_category_profiles?.length
                      ? "mt-2"
                      : "mt-2"
                  }`}
                >
                  No Business  Available in this Provider

                </h6>}
                </Swiper>
                </div>
                <div style={{height:"80px"}}>
                <div
                  className="w-full mt-2"
                  style={{ border: "1px solid black" }}
                />
                <h6 className="mt-2 font-weight-bold">
                Service Categories
                </h6>
                {selectedprofile?.provider_category_services?.length ? (
                  <Swiper
                    className="mt-2"
                    slidesPerView={4}
                    spaceBetween={2}
                    navigation={{
                      nextEl: ".next",
                      prevEl: ".prev",
                    }}
                    modules={[Navigation]}
                  >
                    {selectedprofile?.provider_category_services?.map((e) => {
                      return (
                        <SwiperSlide key={e.id}>
                          <button
                            className="btn-defaultS"
                            style={{
                              backgroundColor:
                                e.id === active ? "black" : "white",
                              color: e.id === active ? "white" : "black",
                              border:
                                e.id === active ? "1px solid black" : "none",
                            }}
                            onClick={() => fetchProviders(e.id)}
                          >
                            {e.name}
                          </button>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                ) : (
                  <h6
                    className={`w-full mt-4 text-danger font-weight-bold ${
                      selectedprofile?.provider_category_services?.length
                        ? "mt-2"
                        : "mt-2"
                    }`}
                  >
                    No Service Categories Available in this Business

                  </h6>
                )}
                </div>
                <div
                  className={`w-full ${
                    selectedprofile?.provider_category_services?.length
                      ? "mt-2"
                      : "mt-2"
                  }`}
                  style={{ border: "1px solid black" }}
                />
                <h6 className="font-weight-bold mt-2">
                Service
                </h6>
                {serviceName?.length? serviceName?.map((e) => {
                  const isSelected = SelectedService?.some(
                    (service) => service.id === e.id
                  );
                  return (
                    <div
                      key={e.id}
                      className={`border border-gray p-3 d-flex flex-wrap justify-content-between align-items-center rounded mt-2`}
                      style={{
                        pointerEvents: !e?.professionals ? "none" : "",
                        backgroundColor: isSelected ? "black" : "white",
                      }}
                    >
                      <div>
                        <h6 className={isSelected ? "text-white" : "text-dark"}>
                          {e?.name}
                        </h6>
                        <p className={isSelected ? "text-white" : "text-dark"}>
                          <div className="d-flex gap-2">
                            {e?.discount ? (
                              <>
                                {/* Original Price with Strike-through */}
                                <h6 style={{ textDecoration: "line-through" }}>
                                  {e?.price} $
                                </h6>
                                {/* Discounted Price */}
                                <h6>
                                  {e?.price - (e?.price * e?.discount) / 100} $
                                  {/* Calculate discounted price */}
                                </h6>
                                {/* Discount Message */}
                                <h6 className="text-success">
                                  Save {e?.discount}%
                                </h6>
                              </>
                            ) : (
                              // Show the price normally if no discount
                              <h6>{e?.price} $</h6>
                            )}
                          </div>
                          <div>{e?.time} mins</div>
                          <div>
                            {!e?.professionals &&  <h6 className="font-weight-bold text-danger">professionals is Not Available in This Service</h6>}
                             
                          </div>
                          <div>{e.description}</div>
                        </p>
                        <p
                          className={isSelected ? "text-white" : "text-dark"}
                        ></p>
                      </div>
                      <div onClick={() => handleToggle(e)}>
                        {isSelected ? (
                          <TiTick
                            onClick={() => {
                              const existingServices =
                                Provider.provider_category_detail
                                  .SelectedService || [];

                              // Check if the service with the same id already exists
                              const serviceExists = existingServices.some(
                                (service) => service.id === e.id
                              );

                              if (serviceExists) {
                                // Remove the service if it exists
                                const updatedServices = existingServices.filter(
                                  (service) => service.id !== e.id
                                );
                                dispatch(
                                  selectedServicesNew({
                                    ...Provider,
                                    provider_category_detail: {
                                      ...Provider.provider_category_detail,
                                      SelectedService: updatedServices, // Update the services without the removed one
                                    },
                                  })
                                );
                                console.log(
                                  "Service removed from SelectedService:",
                                  e
                                );
                              } else {
                                console.log(
                                  "Service already exists in SelectedService:",
                                  e
                                );
                              }
                              // dispatch(toggleService(e)); // Uncomment if you still need this
                            }}
                            style={{
                              backgroundColor: "#F2F2F2",
                              width: "28px",
                              height: "28px",
                              padding: "6px",
                              borderRadius: "8px",
                            }}
                          />
                        ) : (
                          <FaPlus
                            onClick={() => {
                              const existingServices =
                                Provider.provider_category_detail
                                  .SelectedService || [];

                              // Check if the service with the same id already exists
                              const serviceExists = existingServices.some(
                                (service) => service.id === e.id
                              );

                              if (!serviceExists) {
                                dispatch(
                                  selectedServicesNew({
                                    ...Provider,
                                    provider_category_detail: {
                                      ...Provider.provider_category_detail,
                                      SelectedService: [
                                        ...existingServices,
                                        e, // Add the new service if it doesn't exist
                                      ],
                                    },
                                  })
                                );
                              } else {
                                console.log(
                                  "Service already exists in SelectedService:",
                                  e
                                );
                              }
                              // dispatch(toggleService(e)); // Uncomment if you still need this
                            }}
                            style={{
                              backgroundColor: "#F2F2F2",
                              width: "28px",
                              height: "28px",
                              padding: "6px",
                              borderRadius: "8px",
                            }}
                          />
                        )}
                      </div>
                    </div>
                  );
                }): <h6
                className={`w-full font-weight-bold text-danger ${
                  selectedprofile?.provider_category_services?.length
                    ? "mt-2"
                    : "mt-2"
                }`}
              >
                No Service Available in this Service Categories

              </h6>}
              </div>
            )}
          </div>

          <div className="col-md-4 col-12">
            <SelectedServices
            disable={SelectedService?.length>0?false:true}
              // categoryprofile={provider}
              navigate={SelectedService?.length>0?"/professionals":''}
              // ServiceId={ServiceIds}
            />
          </div>
        </div>
      </div>
    </>
  );
}
